export default __webpack_public_path__ + "static/media/README.dd809d6b.md";